<template>
  <div class="container-fluid">
    <div class="row">
      <div class="col-12">
        <div class="card card-form">

          <div class="card-header">
            <div class="row">
              <div class="col">
                <div class="pull-left">
                  <h4 class="card-title float-left">
                    {{ $t("fitment.plus.list") }}
                  </h4>
                </div>
              </div>
            </div>
          </div>

          <div class="card-body">

            <div class="row">
              <div class="col-12 col-md-6">
                <div class="form-group" v-if="fitment.hasCustomerClient">
                  <label>Буйюртмачи <span
                      class="red">*</span></label>
                  <v-select v-model="fitment.customerClient" label="text"
                            :options="customers"
                            :filterable="false"
                            @search="onCustomerSearch"
                            @search:focus="onCustomerFocus"
                            :class="{invalid : $v.fitment.customerClient.$error}">
                    <template slot="option" slot-scope="option" v-if="option && option.text">
                      <div v-html="option.text"></div>
                    </template>
                    <template slot="selected-option"
                              v-if="fitment && fitment.customerClient && fitment.customerClient.text">
                      <div v-html="fitment.customerClient.text"></div>
                    </template>
                    <span slot="no-options">{{ $t("messages.combo.empty") }}</span>
                  </v-select>
                  <div class="red" v-if="$v.fitment.customerClient.$error">
                    Буйюртмачи
                  </div>
                </div>

                <div class="form-group">
                  <label>{{ $t("common.evlPrice") }}</label>
                  <numeric-input class="form-control" v-model="fitment.evlPrice"
                                 :controls="false" :precision="2" :disabled="true"></numeric-input>
                </div>

                <div class="row">
                  <div class="col-12 col-md-6">
                    <div class="form-group">
                      <label>{{ $t("realEstate.field.evaluationRespectiveType") }} <span
                          class="red">*</span></label>
                      <select class="form-control" v-model="fitment.evaluationRespectiveType"
                              :class="{invalid : $v.fitment.evaluationRespectiveType.$error}">
                        <option :value="option.code" v-for="option in evaluationRespectiveTypes"
                                :key="option.code">
                          {{ option.displayName }}
                        </option>
                      </select>
                      <div class="red" v-if="$v.fitment.evlGoalType.$error">
                        {{ $t("realEstate.validation.evaluationRespectiveType") }}
                      </div>
                    </div>
                    <div class="form-row" v-if="isTenders">
                      <div class="form-group col-md-6">
                        <label>{{ $t("realEstate.field.tenderContractDate") }} <span class="red">*</span></label>
                        <datepicker class="form-control" format="dd/MM/yyyy"
                                    v-model="tenderContractDate"
                                    :date="tenderContractDate"
                                    :clear-button="true"
                                    :class="{invalid:$v.tenderContractDate.$error}"></datepicker>
                        <div class="red" v-if="$v.tenderContractDate.$error">
                          {{ $t("realEstate.field.tenderContractDate") }}
                        </div>
                      </div>
                      <div class="form-group col-md-6">
                        <label>
                          {{ $t("realEstate.field.tenderContractNumber") }} <span class="red">*</span>
                        </label>
                        <input type="text" class="form-control"
                               :class="{invalid: $v.fitment.tenderContractNumber.$error}"
                               v-model="fitment.tenderContractNumber">
                      </div>
                    </div>
                    <div class="form-group">
                      <label>{{ $t("realEstate.field.ownerClient") }} <span class="red">*</span></label>
                      <v-select v-model="fitment.ownerClient" label="text"
                                :options="owners"
                                :filterable="false"
                                @search="onOwnerSearch"
                                @search:focus="onOwnerFocus"
                                :class="{invalid : $v.fitment.ownerClient.$error}">
                        <template slot="option" slot-scope="option" v-if="option">
                          <div v-html="option.text"></div>
                        </template>
                        <template slot="selected-option"
                                  v-if="fitment && fitment.ownerClient && fitment.ownerClient.text">
                          <div v-html="fitment.ownerClient.text"
                               @click="$eventBus.$emit('search:focus')"></div>
                        </template>
                        <span slot="no-options">{{ $t("messages.combo.empty") }}</span>
                      </v-select>
                      <div class="red" v-if="$v.fitment.ownerClient.$error">
                        {{ $t("realEstate.validation.ownerClient") }}
                      </div>
                    </div>

                    <div class="form-group" v-if="fitment.hasCustomerClient">
                      <label>Ишончнома номери: <span class="red">*</span></label>
                      <input type="text" class="form-control" v-model="fitment.powerOfAttorneyNumber"
                             :class="{invalid : $v.fitment.powerOfAttorneyNumber.$error}"/>
                      <div class="red" v-if="$v.fitment.powerOfAttorneyNumber.$error">Ишончнома номери
                      </div>
                    </div>

                    <div class="form-group" v-if="fitment.hasCustomerClient">
                      <label>Ишончнома санаси: <span class="red">*</span></label>
                      <datepicker class="form-control" format="dd/MM/yyyy"
                                  v-model="powerOfAttorneyDate"
                                  :clear-button="true"
                                  :class="{invalid : $v.powerOfAttorneyDate.$error}"></datepicker>
                      <div class="red" v-if="$v.powerOfAttorneyDate.$error">Ишончнома санаси:
                      </div>
                    </div>

                    <template v-if="isOrgTypeMib">
                      <div class="form-group">
                        <label>{{ $t("realEstate.field.mibDebtorName") }} <span
                            class="red">*</span></label>
                        <input type="text" class="form-control" v-model="fitment.debtor"
                               :class="{invalid : $v.fitment.debtor.$error}"/>
                        <div class="red" v-if="$v.fitment.debtor.$error">
                          {{ $t("realEstate.validation.mibDebtorName") }}
                        </div>
                      </div>
                      <div class="form-group">
                        <label>{{ $t("realEstate.field.mibLetterNumber") }} <span
                            class="red">*</span></label>
                        <input type="text" class="form-control" v-model="fitment.letterNumber"
                               :class="{invalid : $v.fitment.letterNumber.$error}"/>
                        <div class="red" v-if="$v.fitment.letterNumber.$error">
                          {{ $t("realEstate.validation.mibLetterNumber") }}
                        </div>
                      </div>
                      <div class="form-group">
                        <label>{{ $t("realEstate.field.mibLetterDate") }} <span
                            class="red">*</span></label>
                        <datepicker class="form-control" format="dd/MM/yyyy" v-model="contractDate"
                                    :clear-button="true"
                                    :class="{invalid : $v.contractDate.$error}"></datepicker>
                        <div class="red" v-if="$v.contractDate.$error">
                          {{ $t("realEstate.validation.mibLetterDate") }}
                        </div>
                      </div>
                    </template>

                  </div>


                  <div class="col-12 col-md-6">

                    <div class="form-group">
                      <label>{{ $t("realEstate.field.evaluationPurpose") }} <span
                          class="red">*</span></label>
                      <select class="form-control" v-model="fitment.evlGoalType"
                              :class="{invalid : $v.fitment.evlGoalType.$error}">
                        <option :value="option.key" v-for="option in goalTypes" :key="option.key">
                          {{ option.name }}
                        </option>
                      </select>
                      <div class="red" v-if="$v.fitment.evlGoalType.$error">
                        {{ $t("realEstate.validation.evaluationPurpose") }}
                      </div>
                    </div>

                    <div class="form-group">
                      <label>{{ $t("realEstate.field.evaluator") }} <span class="red">*</span></label>
                      <v-select v-model="fitment.employee" label="name"
                                :options="employees"
                                :filterable="false"
                                @search="onEmployeeSearch"
                                @search:focus="onEmployeeFocus"
                                :class="{invalid : $v.fitment.employee.$error}">
                        <template slot="option" slot-scope="option" v-if="option">
                          <div v-html="option.name"></div>
                        </template>
                        <template slot="selected-option"
                                  v-if="fitment && fitment.employee && fitment.employee.name">
                          <div v-html="fitment.employee.name"
                               @click="$eventBus.$emit('search:focus')"></div>
                        </template>
                        <span slot="no-options">{{ $t("messages.combo.empty") }}</span>
                      </v-select>
                      <div class="red" v-if="$v.fitment.employee.$error">
                        {{ $t("realEstate.validation.evaluator") }}
                      </div>
                    </div>

                    <div class="form-group">
                      <label>{{ $t("realEstate.field.contractAmount") }}</label>
                      <numeric-input class="form-control" v-model="fitment.evlContractAmount"
                                     :controls="false" :precision="2"></numeric-input>

                    </div>
                    <div class="form-group">
                      <label>{{ $t("realEstate.field.propertyType") }} <span class="red">*</span></label>
                      <select class="form-control" v-model="fitment.evlPropertyType"
                              :class="{invalid : $v.fitment.evlPropertyType.$error}">
                        <option value=""></option>
                        <option :value="option.key" v-for="option in propertyTypes" :key="option.key">
                          {{ option.name }}
                        </option>
                      </select>
                      <div class="red" v-if="$v.fitment.evlPropertyType.$error">
                        {{ $t("realEstate.validation.propertyType") }}
                      </div>
                    </div>
                  </div>


                  <div class="col-12">
                    <div class="form-group">
                      <label>{{ $t("realEstate.field.evaluatorIdea") }}</label>
                      <textarea type="text" class="form-control"
                                v-model="fitment.evaluatorIdea"></textarea>
                    </div>
                    <div class="form-group">
                      <label>Чекловчи шартлар</label>
                      <textarea type="text" class="form-control"
                                v-model="fitment.evaluatorRestrictiveTerms"></textarea>
                    </div>
                  </div>
                </div>
              </div>


              <div class="col-12 col-md-6">
                <b-form-group v-slot="{ ariaDescribedby }">
                  <b-form-radio-group
                      v-model="selectedFitmentDocsTab"
                      :options="[
                                { text: 'Ижро варакаси', value: 'docs' },
                                { text: 'мурожат хати', value: 'docs' },
                                { text: 'Акт', value: 'docs' },
                                { text: 'Карор', value: 'docs' }
                                ]"
                      :aria-describedby="ariaDescribedby"
                      button-variant="form-radio-group"
                      name="radio-btn-outline1"
                      buttons
                  ></b-form-radio-group>
                </b-form-group>

                <div v-if="selectedFitmentDocsTab === 'docs'" class="px-3">
                  <carousel :perPage="1"
                            :navigationEnabled="true"
                            :navigationNextLabel="next"
                            :navigationPrevLabel="prev">
                    <slide v-for="(photo) in letterAllFiles" v-bind:key="photo.id">
                      <div v-if="photo && photo.type !== 'application/pdf'">
                        <inner-image-zoom :src="photo.filePath"
                                          :height="500"
                                          :hideHint="true"
                                          :zoomScale="1.2"
                        ></inner-image-zoom>
                      </div>
                      <div v-else-if="photo && photo.type === 'application/pdf'">
                        <iframe :src="photo.filePath" width="100%"
                                style="height: 600px"></iframe>
                      </div>
                    </slide>
                  </carousel>
                </div>

                <div v-if="selectedFitmentDocsTab === 'docs'" class="px-3">
                  <carousel :perPage="1"
                            :navigationEnabled="true"
                            :navigationNextLabel="next"
                            :navigationPrevLabel="prev">
                    <slide v-for="(photo) in actOfSaleAllFiles" v-bind:key="photo.id">
                      <div v-if="photo && photo.type !== 'application/pdf'">
                        <inner-image-zoom :src="photo.filePath"
                                          :height="500"
                                          :hideHint="true"
                                          :zoomScale="1.2"
                        ></inner-image-zoom>
                      </div>
                      <div v-else-if="photo && photo.type === 'application/pdf'">
                        <iframe :src="photo.filePath" width="100%"
                                style="height: 600px"></iframe>
                      </div>
                    </slide>
                  </carousel>
                </div>
                <div v-if="selectedFitmentDocsTab === 'docs'" class="px-3">
                  <carousel :perPage="1"
                            :navigationEnabled="true"
                            :navigationNextLabel="next"
                            :navigationPrevLabel="prev">
                    <slide v-for="(photo) in decisionAllFiles" v-bind:key="photo.id">
                      <div v-if="photo && photo.type !== 'application/pdf'">
                        <inner-image-zoom :src="photo.filePath"
                                          :height="500"
                                          :hideHint="true"
                                          :zoomScale="1.2"
                        ></inner-image-zoom>
                      </div>
                      <div v-else-if="photo && photo.type === 'application/pdf'">
                        <iframe :src="photo.filePath" width="100%"
                                style="height: 600px"></iframe>
                      </div>
                    </slide>
                  </carousel>
                </div>
                <div v-if="selectedFitmentDocsTab === 'docs'" class="px-3">
                  <carousel :perPage="1"
                            :navigationEnabled="true"
                            :navigationNextLabel="next"
                            :navigationPrevLabel="prev">
                    <slide v-for="(photo) in executivePlaylistAllFiles" v-bind:key="photo.id">
                      <div v-if="photo && photo.type !== 'application/pdf'">
                        <inner-image-zoom :src="photo.filePath"
                                          :height="500"
                                          :hideHint="true"
                                          :zoomScale="1.2"
                        ></inner-image-zoom>
                      </div>
                      <div v-else-if="photo && photo.type === 'application/pdf'">
                        <iframe :src="photo.filePath" width="100%"
                                style="height: 600px"></iframe>
                      </div>
                    </slide>
                  </carousel>
                </div>
              </div>

            </div>

            <div class="row">
              <div class="col-12">
                <div class="section-header font-weight-bold colllapse-header">
                  <div>
                    <h4>
                      {{ $t("fitment.list") }}
                    </h4>
                  </div>
                </div>
                <div class="row" v-if="fitment.id && fitment.id > 0">
                  <div class="col-md-8">
                    <div class="form-group" v-if="fitment.approachCost">
                      <label>{{ $t("realEstate.field.cadastreSection") }} <span class="red">*</span></label>
                      <div class="row">
                        <div class="col-md-12">

                        </div>
                      </div>
                    </div>
                    <!--                      <div class="red" v-if="$v.fitment.sections.$error">-->
                    <!--                        {{$t("realEstate.validation.cadastreSection")}}-->
                    <!--                      </div>-->
                  </div>
                  <div class="col-md-4">
                    <button class="all-btn btn-sm add-btn pull-right mr-3"
                            v-tooltip="$t('realEstate.field.addBuilding')" @click="addFitments">
                      <i class="fa fa-plus"></i>
                    </button>
                  </div>
                  <div class="col-12">
                    <section v-for="(item, index) in fitment.evaluationFitments" :key="item.id">
                      <div class="row">
                        <div class="col-12">
                          <div role="tablist">
                            <div class="card">
                              <div class="card-header bg-light">
                                <div class="row">
                                  <div class="col-12 col-md-4" v-b-toggle="'collapse'+index" style="cursor: pointer"
                                       v-tooltip="'Маълумотларни очиш'">
                                    <span><i class="fa fa-arrow-down"></i><b>№{{ index + 1 }}.(#id:{{
                                        item.id
                                      }})</b></span>
                                  </div>
                                  <div class="col-12 col-md-3">
                                    <span><b>{{ item.name }}</b></span>
                                  </div>

                                  <div class="col-12 col-md-2">
                                    <div class="pull-right d-flex align-items-center">
                                      <button class="all-btn delete-btn" @click="removeItem(item)"
                                              :disabled="processing">
                                        {{ $t("action.delete") }}
                                      </button>


                                      <button type="button" v-tooltip="'Saqlash'" :disabled="processing"
                                              class="all-btn table-action"
                                              @click="saveItem(item)">
                                        {{ $t("action.save") }}
                                      </button>

                                    </div>
                                  </div>
                                </div>
                                <div class="row">
                                  <div class="col-12">
                                    <hr/>
                                  </div>
                                </div>

                              </div>

                              <b-collapse :id="'collapse'+index" accordion="my-accordion" role="tabpanel">
                                <div class="card-body">
                                  <div class="row">


                                    <div class="col-12 col-md-6">
                                      <div class="row">
                                        <div class="col-12 col-md-6">

                                          <div class="form-group">
                                            <label
                                                :class="$v.fitment.evaluationFitments.$each[index].productCategoryPlusDto.$error ? 'red' : ''">
                                              {{ $t('config.products.productCategory.title') }}<span
                                                class="red">*</span></label>
                                            <v-select v-model="item.productCategoryPlusDto" label="name"
                                                      :class="{invalid : $v.fitment.evaluationFitments.$each[index].productCategoryPlusDto.$error}"
                                                      :options="productCategories"
                                                      :filterable="false"
                                                      @search="onCategorySearch"
                                                      @search:focus="onCategoryFocus">
                                              <template slot="option" slot-scope="option" v-if="option">
                                                <div v-html="option.name"></div>
                                              </template>
                                              <template slot="selected-option"
                                                        v-if="item.productCategoryPlusDto && item.productCategoryPlusDto && item.productCategoryPlusDto.name">
                                                <div v-html="item.productCategoryPlusDto.name"
                                                     @click="$eventBus.$emit('search:focus')"></div>
                                              </template>
                                              <span slot="no-options">{{ $t("empty") }}</span>
                                            </v-select>
                                          </div>

                                          <div class="form-group">
                                            <label
                                                :class="$v.fitment.evaluationFitments.$each[index].productManufactureDto.$error ? 'red' : ''">
                                              {{ $t('config.products.productManufacture.title') }}<span
                                                class="red">*</span></label>
                                            <v-select v-model="item.productManufactureDto" label="name"
                                                      :class="{invalid : $v.fitment.evaluationFitments.$each[index].productManufactureDto.$error}"
                                                      :options="manufactures"
                                                      :filterable="false"
                                                      @search="onProductManufactureSearch(index)"
                                                      @search:focus="onProductManufactureFocus(index)">
                                              <template slot="option" slot-scope="option" v-if="option">
                                                <div v-html="option.name"></div>
                                              </template>
                                              <template slot="selected-option"
                                                        v-if="item && item.productManufactureDto && item.productManufactureDto.name">
                                                <div v-html="item.productManufactureDto.name"
                                                     @click="$eventBus.$emit('search:focus')"></div>
                                              </template>
                                              <span slot="no-options">{{ $t("empty") }}</span>
                                            </v-select>
                                          </div>

                                          <div class="form-group">

                                            <label
                                                :class="$v.fitment.evaluationFitments.$each[index].countryDto.$error ? 'red' : ''">
                                              {{
                                                item.fitmentType === 'JEWELRY' ? 'Заргарлик буйум ишлаб чиққарилган мамлакат' : $t("fitment.madeCountry")
                                              }} <span class="red">*</span></label>
                                            <v-select v-model="item.countryDto" label="name"
                                                      :options="countryList"
                                                      :filterable="false"
                                                      @search="onCountrySearch"
                                                      @search:focus="onCountryFocus"
                                                      :class="{invalid : $v.fitment.evaluationFitments.$each[index].countryDto.$error}">
                                              <template slot="option" slot-scope="option" v-if="option">
                                                <div v-html="option.name"></div>
                                              </template>
                                              <template slot="selected-option"
                                                        v-if="item && item.countryDto && item.countryDto.name">
                                                <div v-html="item.countryDto.name"
                                                     @click="$eventBus.$emit('search:focus')"></div>
                                              </template>
                                              <span slot="no-options">{{ $t("messages.combo.empty") }}</span>
                                            </v-select>
                                          </div>

                                          <div class="form-group">
                                            <label
                                                :class="$v.fitment.evaluationFitments.$each[index].useWebSite.$error ? 'red' : ''">
                                              {{ $t("fitment.useWebSite") }} <span class="red">*</span></label>
                                            <input type="text" class="form-control" v-model="item.useWebSite"
                                                   :class="{invalid : $v.fitment.evaluationFitments.$each[index].useWebSite.$error}"/>
                                          </div>

                                          <div class="form-group">
                                            <label>Олдин ишлатилган ID</label>
                                            <input type="text" :disabled="true" class="form-control"
                                                   v-model="fitment.fitmentParentId"/>
                                          </div>

                                          <div class="form-group"
                                               v-if="item.fitmentType && item.fitmentType === 'JEWELRY'">
                                            <label
                                                :class="$v.fitment.evaluationFitments.$each[index].overlayCoefficient.$error ? 'red' : ''">
                                              {{ $t("fitment.overlayCoefficient") }} <span
                                                class="red">*</span></label>
                                            <numeric-input class="form-control" v-model="item.overlayCoefficient"
                                                           :class="{invalid : $v.fitment.evaluationFitments.$each[index].overlayCoefficient.$error}"
                                                           :controls="false" :precision="3"></numeric-input>
                                          </div>

                                          <div class="form-group"
                                               v-if="item.fitmentType && item.fitmentType !== 'JEWELRY' &&
                                                  item.fitmentType === 'INSTRUMENTS_INVENTORY_ANIMALS_EQUIPMENT_FIXED_ASSETS'">
                                            <label
                                                :class="$v.fitment.evaluationFitments.$each[index].dilapidationValue.$error ? 'red' : ''">
                                              {{ $t("fitment.dilapidationValue") }}
                                            </label>
                                            <numeric-input class="form-control"
                                                           v-model="item.dilapidationValue"
                                                           @input="changeDilapidationValue14(index)"
                                                           :class="{invalid : $v.fitment.evaluationFitments.$each[index].dilapidationValue.$error}"
                                                           :precision="0"
                                            ></numeric-input>
                                          </div>

                                          <div class="form-group"
                                               v-if="item.fitmentType && item.fitmentType !== 'JEWELRY' &&
                                                 (item.fitmentType === 'BUILDINGS_TRANSMITTERS_MACHINERY_EQUIPMENT' || item.fitmentType === 'OTHER') ">

                                            <label
                                                :class="$v.fitment.evaluationFitments.$each[index].dilapidationValue.$error ? 'red' : ''">
                                              {{ $t("fitment.dilapidationValue") }}
                                              <span class="red">*</span>
                                            </label>

                                            <select class="form-control" v-model="item.dilapidationValue"
                                                    :class="{invalid : $v.fitment.evaluationFitments.$each[index].dilapidationValue.$error}"
                                                    @change="changeDilapidationValue15(index)">
                                              <option value=""></option>
                                              <option :value="option" v-for="option in dilapidation15" :key="option">
                                                {{ option }}
                                              </option>
                                            </select>

                                          </div>

                                        </div>


                                        <div class="col-12 col-md-6">

                                          <div class="form-group">
                                            <label
                                                :class="$v.fitment.evaluationFitments.$each[index].productSubCategoryPlusDto.$error ? 'red' : ''">
                                              {{ $t('config.products.productSubCategory.title') }}<span
                                                class="red">*</span></label>
                                            <v-select v-model="item.productSubCategoryPlusDto" label="name"
                                                      :class="{invalid : $v.fitment.evaluationFitments.$each[index].productSubCategoryPlusDto.$error}"
                                                      :options="productSubCategories"
                                                      :filterable="false"
                                                      @search="onSubCategorySearch(index)"
                                                      @search:focus="onSubCategoryFocus(index)"
                                                      @input="onChangeMethodSub(index)">
                                              <template slot="option" slot-scope="option" v-if="option">
                                                <div v-html="option.name"></div>
                                              </template>
                                              <template slot="selected-option"
                                                        v-if="item && item.productSubCategoryPlusDto && item.productSubCategoryPlusDto.name">
                                                <div v-html="item.productSubCategoryPlusDto.name"
                                                     @click="$eventBus.$emit('search:focus')"></div>
                                              </template>
                                              <span slot="no-options">{{ $t("empty") }}</span>
                                            </v-select>
                                          </div>

                                          <div class="form-group">
                                            <label
                                                :class="$v.fitment.evaluationFitments.$each[index].productModelDto.$error ? 'red' : ''">
                                              {{ $t('config.products.productModel.title') }}<span
                                                class="red">*</span></label>
                                            <v-select v-model="item.productModelDto" label="name"
                                                      :class="{invalid : $v.fitment.evaluationFitments.$each[index].productModelDto.$error}"
                                                      :options="productModels"
                                                      :filterable="false"
                                                      @search="onProductModelSearch(index)"
                                                      @change="onProductModelCange(index)"
                                                      @search:focus="onProductModelFocus(index)">
                                              <template slot="option" slot-scope="option" v-if="option">
                                                <div v-html="option.name"></div>
                                              </template>
                                              <template slot="selected-option"
                                                        v-if="item && item.productModelDto && item.productModelDto.name">
                                                <div v-html="item.productModelDto.name"
                                                     @click="$eventBus.$emit('search:focus')"></div>
                                              </template>
                                              <span slot="no-options">{{ $t("empty") }}</span>
                                            </v-select>
                                          </div>

                                          <div class="form-group"
                                               v-if="item.fitmentType && item.fitmentType !== 'JEWELRY'">
                                            <label
                                                :class="$v.fitment.evaluationFitments.$each[index].conditionType.$error ? 'red' : ''">
                                              {{ $t("fitment.partConditions") }} </label>
                                            <select class="form-control" v-model="item.conditionType"
                                                    :class="{invalid : $v.fitment.evaluationFitments.$each[index].conditionType.$error}"
                                            >
                                              <option value=""></option>
                                              <option :value="option.key" v-for="option in partConditions"
                                                      :key="option.key">
                                                {{ option.name }}
                                              </option>
                                            </select>
                                          </div>

                                          <div class="form-group"
                                               v-if="item.fitmentType && item.fitmentType === 'JEWELRY'">
                                            <label
                                                :class="!$v.fitment.evaluationFitments.$each[index].stoneName.$error ? 'red' : ''">
                                              {{ $t("fitment.stoneName") }} </label>
                                            <input type="text" class="form-control"
                                                   :class="{invalid : $v.fitment.evaluationFitments.$each[index].stoneName.$error}"
                                                   v-model="item.stoneName"/>
                                          </div>

                                          <div class="form-group"
                                               v-if="item.fitmentType && item.fitmentType !== 'JEWELRY'">
                                            <label
                                                :class="!$v.fitment.evaluationFitments.$each[index].madeYear.$error ? 'red' : ''">

                                              {{ $t("fitment.madeYear") }} </label>
                                            <input type="text" class="form-control"
                                                   :class="{invalid : $v.fitment.evaluationFitments.$each[index].madeYear.$error}"
                                                   v-model="item.madeYear"/>
                                          </div>


                                          <div class="form-group"
                                               v-if="item.fitmentType && item.fitmentType === 'JEWELRY'">
                                            <label
                                                :class="!$v.fitment.evaluationFitments.$each[index].metalType.$error ? 'red' : ''">
                                              {{ $t("fitment.metalType") }}
                                              <span class="red">*</span>
                                            </label>
                                            <select class="form-control"
                                                    :class="{invalid : $v.fitment.evaluationFitments.$each[index].metalType.$error}"
                                                    @change="calculated(index)"
                                                    v-model="item.metalType">
                                              <option value="GOLD">{{ $t("fitment.gold") }}</option>
                                              <option value="SILVER">{{ $t("fitment.silver") }}</option>
                                            </select>
                                          </div>


                                          <div class="form-group">
                                            <div class="row">
                                              <div class="col-md-6 col-6">
                                                <label
                                                    :class="$v.fitment.evaluationFitments.$each[index].qty.$error ? 'red' : ''">
                                                  {{ $t("fitment.qty") }} <span class="red">*</span></label>
                                                <numeric-input class="form-control" v-model="item.qty"
                                                               :class="{invalid : $v.fitment.evaluationFitments.$each[index].qty.$error}"
                                                               :controls="false" :precision="3"></numeric-input>
                                              </div>

                                              <div class="col-md-5 col-6">
                                                <label>
                                                  Ўлчов бирликлари
                                                </label>
                                                <MeasurementTypeSelect :value="item.um" :with-change="true"
                                                                       @handle-change="umchange(item.um, index)"
                                                                       v-model="item.um"></MeasurementTypeSelect>
                                              </div>

                                              <div class="col-md-6 col-6"
                                                   v-if="item.fitmentType && item.fitmentType === 'JEWELRY'">
                                                <label
                                                    :class="!$v.fitment.evaluationFitments.$each[index].weigh.$error ? 'red' : ''">
                                                  {{ $t("fitment.weigh") }}
                                                  <span class="red">*</span>
                                                </label>
                                                <numeric-input class="form-control" v-model="item.weigh"
                                                               :class="{invalid : $v.fitment.evaluationFitments.$each[index].weigh.$error}"
                                                               :controls="false" :precision="3"></numeric-input>
                                              </div>

                                              <div class="col-md-6 col-6"
                                                   v-if="item.fitmentType && item.fitmentType === 'JEWELRY'">
                                                <label
                                                    :class="!$v.fitment.evaluationFitments.$each[index].hallmark.$error ? 'red' : ''">
                                                  {{ $t("fitment.hallmark") }} <span class="red">*</span></label>
                                                <numeric-input class="form-control" v-model="item.hallmark"
                                                               :class="{invalid : $v.fitment.evaluationFitments.$each[index].hallmark.$error}"
                                                               :controls="false" :precision="3"></numeric-input>
                                              </div>
                                            </div>

                                          </div>

                                          <div class="form-group"
                                               v-if="item.fitmentType && item.fitmentType !== 'JEWELRY'">
                                            <div class="row">
                                              <div class="col-md-6 col-6">
                                                <label
                                                    :class="$v.fitment.evaluationFitments.$each[index].governmentPrice.$error ? 'red' : ''">
                                                  {{ $t("fitment.price") }}
                                                  <span class="red">*</span>
                                                </label>
                                                <numeric-input class="form-control" v-model="item.governmentPrice"
                                                               :class="{invalid : $v.fitment.evaluationFitments.$each[index].governmentPrice.$error}"
                                                               :controls="false" :precision="3"
                                                               @input="calculated(index)"></numeric-input>
                                              </div>
                                              <div class="col-md-6 col-6">
                                                <label
                                                    :class="$v.fitment.evaluationFitments.$each[index].currency.$error ? 'red' : ''">
                                                  {{ $t("config.currency") }}
                                                  <span class="red">*</span>
                                                </label>
                                                <select class="form-control" v-model="item.currency"
                                                        :class="{invalid : $v.fitment.evaluationFitments.$each[index].currency.$error}"
                                                        @change="calculated(index)">
                                                  <option value="UZS">UZS</option>
                                                  <option value="USD">USD</option>
                                                  <option value="EUR">EUR</option>
                                                  <option value="RUB">RUB</option>
                                                </select>
                                              </div>
                                            </div>
                                          </div>

                                          <div class="form-group"
                                               v-if="item.fitmentType && item.fitmentType !== 'JEWELRY'">
                                            <label>{{ $t("fitment.foreign") }}</label>
                                            <label class="form-check-label mb-2 ml-5">
                                              <input class="form-check-input" type="checkbox"
                                                     v-model="item.hasCustomsDuty"
                                                     @change="calculated(index)">
                                              <span class="form-check-sign"></span>
                                            </label>
                                          </div>

                                        </div>

                                      </div>

                                      <div class="form-group" v-if="item.fitmentType && item.fitmentType === 'JEWELRY'">
                                        <label
                                            :class="!$v.fitment.evaluationFitments.$each[index].stonePrice.$error ? 'red' : ''">
                                          {{ $t("fitment.stonePrice") }} <span class="red">*</span></label>
                                        <numeric-input class="form-control" v-model="item.stonePrice"
                                                       :class="{invalid : $v.fitment.evaluationFitments.$each[index].stonePrice.$error}"
                                                       :controls="false" :precision="0"
                                                       @input="calculated(index)"></numeric-input>
                                      </div>

                                      <!--                    <template v-if="!isPageLoadInit">-->
                                      <!--                      <AssetDropZone code="fitmentImageDropZone" label="fitment.photos"-->
                                      <!--                                     folder="FitmentImage" :folderName="'Fitment'"-->
                                      <!--                                     :data="item.fitmentPictures"-->
                                      <!--                                     @change="(files) => {item.fitmentPictures = files}"-->
                                      <!--                                     :removeFile="isRemoveFile"-->
                                      <!--                                     :editable="canSave"-->
                                      <!--                                     :class="'col-md-12'"-->
                                      <!--                      />-->
                                      <!--                    </template>-->
                                      <template v-if="!isPageLoadInit">
                                        <AssetDropZone code="texPassportDropZone" label="fitment.plus.priceListPhoto"
                                                       folder="TexPassport" :folderName="'Fitment'"
                                                       :data="item.fitmentTexPassports"
                                                       @change="(files) => {item.fitmentTexPassports = files}"
                                                       :class="'col-md-12'"
                                        />
                                      </template>

                                    </div>

                                    <div class="col-12 col-md-6">
                                      <b-form-group v-slot="{ ariaDescribedby }">
                                        <b-form-radio-group
                                            v-model="selectedFitmentDocsTab"
                                            :options="[
                                              { text: 'Расмлари', value: 'images' }]"
                                            :aria-describedby="ariaDescribedby"
                                            button-variant="form-radio-group"
                                            name="radio-btn-outline1"
                                            buttons
                                        ></b-form-radio-group>
                                      </b-form-group>

                                      <div v-if="selectedFitmentDocsTab === 'images'" class="px-3">
                                        <carousel :perPage="1"
                                                  :navigationEnabled="true"
                                                  :navigationNextLabel="next"
                                                  :navigationPrevLabel="prev">
                                          <slide v-for="(photo) in item.fitmentPictures" v-bind:key="photo.id">
                                            <div v-if="photo && photo.type !== 'application/pdf'">
                                              <inner-image-zoom :src="photo.filePath"
                                                                :height="500"
                                                                :hideHint="true"
                                                                :zoomScale="1.2"
                                              ></inner-image-zoom>
                                            </div>
                                            <div v-else-if="photo && photo.type === 'application/pdf'">
                                              <iframe :src="photo.filePath" width="100%"
                                                      style="height: 600px"></iframe>
                                            </div>
                                          </slide>
                                        </carousel>
                                      </div>
                                    </div>


                                  </div>

                                  <div class="calculate row m-1">
                                    <div class="col-4">
                                      <h4 class="ml-3 text-primary">
                                        <b>Харажат усулдаги қиймати:<br/></b>
                                      </h4>
                                      <h4 class="ml-3 text-primary">
                                        <b>{{ item.totalGovPrice | currency('', 0, {thousandsSeparator: ' '}) }}
                                          сўм</b>
                                      </h4>
                                    </div>
                                    <div class="col-4">
                                <span class="mr-3">
                                    Техник холати:
                                    <b>{{ technicalConditionText }}<br/><br/></b>
                                </span>
                                      <span class="mr-3" v-if="item.currency === 'USD'">
                                    Доллар курси:
                                    <b>{{
                                        item.usdCurrencyRate | currency('', 2, {thousandsSeparator: ' '})
                                      }} сўм<br/><br/></b>
                                </span>
                                      <span class="mr-3" v-if="item.currency === 'EUR'">
                                    Евро курси:
                                    <b>{{
                                        item.eurCurrencyRate | currency('', 2, {thousandsSeparator: ' '})
                                      }} сўм<br/><br/></b>
                                </span>
                                      <span class="mr-3" v-if="item.currency === 'RUB'">
                                    Рубл курси:
                                    <b>{{
                                        item.rubCurrencyRate | currency('', 2, {thousandsSeparator: ' '})
                                      }} сўм<br/><br/></b>
                                </span>
                                      <span v-if="item.fitmentType && item.fitmentType !== 'JEWELRY'">
                                    Эскириш қиймати:
                                    <b>{{ item.dilapidationValue }} %<br/><br/></b>
                                </span>
                                      <span v-if="item.fitmentType && item.fitmentType === 'JEWELRY'">
                                    1 грамм соф {{ item.metalTypeName }}нинг жаҳон бозоридаги нархи :
                                    <b>{{
                                        item.gramPriceInSum | currency('', 2, {thousandsSeparator: ' '})
                                      }} сўм<br/><br/></b>
                                </span>
                                      <span>
                                    Энг кам иш хакки:
                                    <b>{{ minSalary | currency('', 2, {thousandsSeparator: ' '}) }} сўм</b>
                                </span>
                                    </div>
                                    <div class="col-4">
                                <span class="mr-3" v-if="fitment.hasCustomsDuty">
                                    Солик ставкаси (ККС):
                                    <b>{{ item.vat }} %<br/><br/></b>
                                </span>
                                      <span class="mr-3" v-if="item.hasCustomsDuty">
                                    Транспорт харажатлари:
                                    <b>{{ item.road }} %<br/><br/></b>
                                </span>
                                      <span class="mr-3" v-if="item.hasCustomsDuty">
                                    Божхона хужжатларини расмийлаштириш:
                                    <b>{{
                                        item.customsClearance | currency('', 2, {thousandsSeparator: ' '})
                                      }} {{ isNewStandard ? 'сўм' : '%' }}<br/><br/></b>
                                </span>
                                      <span class="mr-3" v-if="item.hasCustomsDuty">
                                    Божхона божи:
                                    <b>{{ item.customsDuty }} %</b>
                                </span>
                                    </div>
                                  </div>
                                </div>
                              </b-collapse>

                            </div>
                          </div>
                        </div>
                      </div>
                    </section>
                  </div>
                </div>
              </div>
            </div>

            <div class="row" v-if="showReportButton">
              <div class="col-12 btns-box">
                <button
                    class="all-btn pull-right btn-sm"
                    v-if="hasPermission('NEW_FITMENT_REPORT_WORD_QR_CODE')"
                    @click="reportDocQrCode(fitment)">
                  <i v-if="loading.isDocQrLoading" class="fa fa-spinner fa-spin"></i>
                  {{ $t("realEstate.report.titleWordQrCode") }}
                </button>
                <button
                    class="all-btn pull-right btn-sm"
                    v-if="hasPermission('NEW_FITMENT_REPORT_WORD')"
                    @click="reportDoc(fitment)">
                  <i v-if="loading.isDocLoading" class="fa fa-spinner fa-spin"></i>
                  {{ $t("realEstate.report.titleWord") }}
                </button>
                <button class="all-btn pull-right btn-sm"
                        v-if="hasPermission('NEW_FITMENT_REPORT_PDF_QR_CODE')"
                        @click="reportPdfQrCode(fitment)">
                  <i v-if="loading.isPdfQrLoading" class="fa fa-spinner fa-spin"></i>
                  {{ $t("realEstate.report.titleQrCode") }}
                </button>
                <button class="all-btn pull-right btn-sm"
                        v-if="hasPermission('NEW_FITMENT_REPORT_PDF')"
                        @click="reportPdf(fitment)">
                  <i v-if="loading.isPdfLoading" class="fa fa-spinner fa-spin"></i>
                  {{ $t("realEstate.report.title") }}
                </button>
                <button class="all-btn pull-right btn-sm"
                        v-if="hasPermission('NEW_FITMENT_CONTRACT_PDF_QR_CODE')"
                        @click="contractQrCodePdf(fitment)">
                  <i v-if="loading.isCPdfQrLoading" class="fa fa-spinner fa-spin"></i>
                  {{ $t("realEstate.report.titleContractPdfQrCode") }}
                </button>
                <button class="all-btn pull-right btn-sm"
                        v-if="hasPermission('NEW_FITMENT_CONTRACT_PDF')"
                        @click="contractPdf(fitment)">
                  <i v-if="loading.isCPdfLoading" class="fa fa-spinner fa-spin"></i>
                  {{ $t("realEstate.report.titleContractPdf") }}
                </button>
                <button class="all-btn pull-right btn-sm"
                        v-if="hasPermission('NEW_FITMENT_CONTRACT_WORD_QR_CODE')"
                        @click="contractDocQrCode(fitment)">
                  <i v-if="loading.isCDocQrLoading" class="fa fa-spinner fa-spin"></i>
                  {{ $t("realEstate.report.titleContractWordQrCode") }}
                </button>
                <button class="all-btn pull-right btn-sm"
                        v-if="hasPermission('NEW_FITMENT_CONTRACT_WORD')"
                        @click="contractDoc(fitment)">
                  <i v-if="loading.isCDocLoading" class="fa fa-spinner fa-spin"></i>
                  {{ $t("realEstate.report.titleContractWord") }}
                </button>

                <button class="btn btn-primary pull-right mr-2 btn-sm"
                        v-if="hasPermission('NEW_FITMENT_REPORT_PDF_NOT_SIGNED_AND_QRCODE')"
                        @click="notSignedAndQRCodeReportPdf(fitment)">
                  <i v-if="loading.isPdfNotSignedAndQRCodeLoading" class="fa fa-spinner fa-spin"></i>
                  {{ $t("realEstate.report.title") }}
                </button>
                <button
                    class="btn btn-primary pull-right mr-2 btn-sm"
                    v-if="hasPermission('NEW_FITMENT_REPORT_WORD_NOT_SIGNED_AND_QRCODE')"
                    @click="notSignedAndQRCodeReportDoc(fitment)">
                  <i v-if="loading.isDocNotSignedAndQRCodeLoading" class="fa fa-spinner fa-spin"></i>
                  {{ $t("realEstate.report.titleWord") }}
                </button>
              </div>
            </div>

            <div class="row">
              <div class="col-12 col-md-6 mt-2">
                <div class="form-group">
                  <fitment-status-view :fitment="fitment" v-if="fitment.id"/>
                </div>
              </div>
              <div class="col-12 col-md-6 mt-2">
                <div class="form-group">
                  <fitment-history-view v-if="fitment.id"/>
                </div>
              </div>
            </div>
          </div>

          <div class="row mt-5">
            <div class="col-12 btns-box">
              <button class="all-btn delete-btn" @click="cancel" :disabled="processing">
                {{ $t("action.cancel") }}
              </button>
              <button class="all-btn add-btn" v-if="canSave" @click="save" :disabled="processing">
                {{ $t("action.save") }}
              </button>
              <button class="all-btn" @click="changeStatus('Rated')" :disabled="processing" v-if="canEvaluate">
                {{ $t("realEstate.action.evaluate") }}
              </button>
              <button class="all-btn add-btn" @click="changeStatus('Confirmed')" :disabled="processing"
                      v-if="canConfirm && (fitment.appraiserReportEsp || !fitment.hasEsp)">
                {{ $t("realEstate.action.confirm") }}
              </button>
              <button class="all-btn" @click="openSignPageAppraiser(fitment)" :disabled="processing"
                      v-if="canConfirm && fitment.hasEsp && !fitment.appraiserReportEsp">
                Баҳоловчи тасдиқлаш (ЭЦП)
              </button>
              <button class="all-btn add-btn" @click="openSignPageDirector(fitment)"
                      :disabled="processing"
                      v-if="hasPermission('NEW_FITMENT_CONFIRM') && fitment.appraisalStatusEnum === 'Confirmed' && fitment.hasEsp && fitment.appraiserReportEsp && !fitment.directorReportEsp">
                Директор тасдиқлаш (ЭЦП)
              </button>
              <button class="all-btn edit-btn" @click="changeStatus('Unreviewed')"
                      :disabled="processing" v-if="canReEvaluate">
                {{ $t("realEstate.action.reevaluate") }}
              </button>

              <button class="all-btn delete-btn" @click="deleteFitment(fitment)"
                      v-if="hasPermission('NEW_FITMENT_DELETE')">
                {{ $t("realEstate.delete.title") }}
              </button>

              <button class="all-btn add-btn" @click="sendReportToMIBAsset(fitment)"
                      v-if="hasPermission('NEW_FITMENT_SEND_TO_MIB') && isMib && fitment.appraisalStatusEnum === 'Confirmed'">
                {{ $t("realEstate.action.sendReportToMIB") }}
              </button>
              <button class="all-btn delete-btn" v-if="canReject" @click="rejectOrder">
                <i class="fa fa-reply-all"></i>
                <span>Рад қилиш</span>
              </button>

            </div>
          </div>

          <div class="row mt-3" v-if="fitment.appraisalStatusEnum === 'Confirmed'">
            <div class="col">
              <div class="alert alert-warning d-flex">
                <i class="fa-fw fa fa-warning mr-1"></i>
                <label style="color: #4d2600; font-size: 14px"><strong>ЭЦП оркали имзолаш! </strong>
                  Тасдиқлагандан (қайта Тасдиқлагандан сўнг хам) ЭЦПни имзоланг. ЭЦП имзолаш
                  тугмасини босинг!</label>
              </div>
            </div>
          </div>

        </div>
      </div>
    </div>
    <RejectComment/>
  </div>
</template>

<script>
import Datepicker from 'vuejs-datepicker';
import {numericTypes} from '@/shared/constants/mask'
import {EVL_GOAL_TYPES, EVL_PROPERTY_TYPES} from '@/shared/constants/realEstate'
import initFilterModel from '@/shared/filter';
import AssetDropZone from '@/views/asset/AssetDropZone'
import {required, requiredUnless, minLength, minValue} from 'vuelidate/lib/validators';
import {formatDate, parseDate} from '@/shared/utils';
import PreviewDropZone from '@/views/real-estate/PreviewDropZone'
import FitmentStatusView from '@/views/fitment/FitmentStatusView.vue'
import FitmentHistoryView from '@/views/fitment/FitmentHistoryView.vue'
import RejectComment from '@/components/RejectComment';
import InnerImageZoom from 'vue-inner-image-zoom';
import {BCollapse} from 'bootstrap-vue/es/components/collapse/collapse';
import {VBToggle} from 'bootstrap-vue/es/directives/toggle/toggle'
import {BFormRadioGroup} from 'bootstrap-vue/es/components/form-radio/form-radio-group'
import {BFormGroup} from 'bootstrap-vue/es/components/form-group/form-group'
import {PART_CONDITION} from "@/shared/constants/fitment";
import MeasurementTypeSelect from '@/components/MeasurementTypeSelect';
import {mapState} from "vuex";

export default {
  name: "fitment-add-edit",
  components: {
    AssetDropZone,
    Datepicker,
    PreviewDropZone,
    FitmentStatusView,
    FitmentHistoryView,
    RejectComment,
    BCollapse,
    BFormGroup,
    BFormRadioGroup,
    InnerImageZoom,
    MeasurementTypeSelect
  },
  directives: {
    'b-toggle': VBToggle
  },
  data() {
    return {
      processing: false,
      loading: {
        isDocQrLoading: false,
        isDocLoading: false,
        isPdfLoading: false,
        isPdfQrLoading: false,
        isCDocLoading: false,
        isCPdfLoading: false,
        isCDocQrLoading: false,
        isCPdfQrLoading: false,
        isDocNotSignedAndQRCodeLoading: false,
        isPdfNotSignedAndQRCodeLoading: false
      },
      show: false,
      isPageLoadInit: false,
      numericTypes: numericTypes,
      ownerFilter: initFilterModel(),
      customerFilter: initFilterModel(),
      employeeFilter: initFilterModel(),
      productCategoryFilter: initFilterModel(),
      productManufactureFilter: initFilterModel(),
      productModelFilter: initFilterModel(),
      subCategoryFilter: initFilterModel(),
      filter: initFilterModel(),
      selectedFitmentDocsTab: "images",
      prev: '<i class="material-icons">keyboard_arrow_left</i>',
      next: '<i class="material-icons">keyboard_arrow_right</i>',
      letterAllFiles: [],
      actOfSaleAllFiles: [],
      decisionAllFiles: [],
      executivePlaylistAllFiles: [],
      isAddValueCollapse: false,
      technicalConditionText: '',
      fitment: {
        id: null,
        ownerClient: {},
        evlObjectType: 'Fitment',
        evlGoalType: null,
        evlContractAmount: 0,
        prepayment: 0,
        employee: {},
        evlValueType: 'Market',
        evlPropertyType: '',

        debtor: '',
        letterNumber: null,
        contractDate: null,
        displayReport: false,
        hasCustomerClient: false,
        customerClient: null,
        powerOfAttorneyDate: null,
        powerOfAttorneyNumber: null,
        evaluationFitments: [
          {
            id: null,
            productCategoryPlusDto: {},
            productSubCategoryPlusDto: {},
            productManufactureDto: {},
            productModelDto: {},
            conditionType: null,
            fitmentType: null,
            fitmentPictures: [],
            fitmentTexPassports: [],
            appraisalStatusEnum: 'Unreviewed',
            parentStatus: 'Pending',
            parentAppraisalStatusEnum: 'Unreviewed',
            metalType: null,
            um: null,
            metalTypeName: '',
            qty: 0,
            dilapidationValue: null,
            governmentPrice: null,
            technicalCondition: null,
            totalGovPrice: 0,
            stonePrice: null,
            hallmark: null,
            weigh: null,
            overlayCoefficient: null,
            useWebSite: null,
            fitmentParentId: null,
            apiData: false,
            hasCustomsDuty: false,
            currency: null,
            countryDto: null,
            usdCurrencyRate: 0,
            eurCurrencyRate: 0,
            rubCurrencyRate: 0,
            vat: 0,
            road: 0,
            customsClearance: 0,
            customsDuty: 0,
            gramPriceInSum: 0
          },
        ],


        letterFiles: [],
        actOfSaleFiles: [],
        decisionFiles: [],
        executivePlaylistFiles: [],
        checkPaymentFiles: [],// to'lov haqidagi hujjatlar
        appraisalStatusEnum: null,
        evaluationRespectiveType: "OTHER",
        tenderContractDate: null,
        tenderContractNumber: null,
        evaluatorIdea: '',
        evaluatorRestrictiveTerms: ''
      },

      productCategories: [],
      productSubCategories: [],
      manufactures: [],
      productModels: [],
      countryList: [],
      dilapidation15: [0, 5, 10, 15, 20, 25, 30, 35, 40, 45, 50, 55, 60, 65, 70, 75, 80, 85, 90, 97.5, 100],
      tenderContractDate: null,
      contractDate: null,
      powerOfAttorneyDate: null,
      owners: [],
      customers: [],
      employees: [],
      goalTypes: EVL_GOAL_TYPES,
      propertyTypes: EVL_PROPERTY_TYPES,
      partConditions: PART_CONDITION,
      evaluationRespectiveTypes: [],
      status: null,
      isDirector: false,
      isAppraiser: false,
      isNewStandard: false,
      minSalary: 0
    }
  },
  validations() {
    return {
      fitment: {
        ownerClient: {
          required: required
        },
        customerClient: {
          required: requiredUnless(() => {
            return !(this.fitment.hasCustomerClient);
          })
        },
        powerOfAttorneyNumber: {
          required: requiredUnless(() => {
            return !(this.fitment.hasCustomerClient);
          })
        },
        evlGoalType: {
          required: required
        },
        evlPropertyType: {
          required: required
        },
        employee: {
          id: {
            required: required
          }
        },
        letterFiles: {
          required: requiredUnless(() => {
            return !this.isMib;
          }),
          minLength: minLength(1)
        },
        actOfSaleFiles: {
          required: requiredUnless(() => {
            return !(this.isOrgTypeMib);
          }),
          minLength: minLength(1)
        },
        decisionFiles: {
          required: requiredUnless(() => {
            return !(this.isOrgTypeMib);
          }),
          minLength: minLength(1)
        },
        // MIB
        debtor: {
          required: requiredUnless(() => {
            return !(this.isOrgTypeMib);
          })
        },
        letterNumber: {
          required: requiredUnless(() => {
            return !(this.isOrgTypeMib);
          })
        },
        evaluationRespectiveType: {
          required: required
        },
        tenderContractNumber: {
          required: requiredUnless(() => {
            return !this.isTenders;
          })
        },
        evaluationFitments: {
          $each: {
            productCategoryPlusDto: {
              id: {
                required: required
              }
            },
            productSubCategoryPlusDto: {
              id: {
                required: required
              }
            },
            productManufactureDto: {
              id: {
                required: required
              }
            },
            productModelDto: {
              id: {
                required: required
              }
            },
            countryDto: {
              id: {
                required: required
              }
            },
            qty: {
              required: requiredUnless(() => {
                return (this.entiteCreateType === 'EXPERT2') && minValue(1);
              }),
            },
            hallmark: {
              required: requiredUnless(() => {
                return (this.fitmentType !== 'JEWELRY');
              })
            },
            weigh: {
              required: requiredUnless(() => {
                return (this.fitmentType !== 'JEWELRY');
              })
            },
            stoneName: {
              required: requiredUnless(() => {
                return (this.fitmentType !== 'JEWELRY');
              })
            },
            madeYear: {
              required: requiredUnless(() => {
                return (this.fitmentType !== 'JEWELRY');
              })
            },
            metalType: {
              required: requiredUnless(() => {
                return (this.fitmentType !== 'JEWELRY');
              })
            },
            stonePrice: {
              required: requiredUnless(() => {
                return (this.fitmentType !== 'JEWELRY');
              })
            },
            overlayCoefficient: {
              required: requiredUnless(() => {
                return (this.fitmentType !== 'JEWELRY');
              })
            },
            conditionType: {
              required: requiredUnless(() => {
                return (this.fitmentType !== 'JEWELRY');
              })
            },
            useWebSite: {
              required: required
            },
            dilapidationValue: {
              required: requiredUnless(() => {
                return (this.fitment.fitmentType !== 'JEWELRY');
              })
            },
            governmentPrice: {
              required: requiredUnless(() => {
                return (this.fitmentType !== 'JEWELRY' || this.entiteCreateType === 'EXPERT2');
              })
            },
            currency: {
              required: requiredUnless(() => {
                return (this.fitmentType !== 'JEWELRY' || this.entiteCreateType === 'EXPERT2');
              })
            }
          }
        }
      },
      contractDate: {
        required: requiredUnless(() => {
          return !this.isOrgTypeMib;
        })
      },
      tenderContractDate: {
        required: requiredUnless(() => {
          return !this.isTenders;
        })
      },
      powerOfAttorneyDate: {
        required: requiredUnless(() => {
          return !(this.fitment.hasCustomerClient);
        })
      }
    };
  },
  computed: {
    ...mapState(['profile']),
    isOwnerTypePhysical() {
      return !!(this.fitment.ownerClient && this.fitment.ownerClient.type && this.fitment.ownerClient.type === 'Physical');
    },
    isOwnerTypeLegal() {
      return !!(this.fitment.ownerClient && this.fitment.ownerClient.type && this.fitment.ownerClient.type === 'Legal');
    },
    isMib() {
      return !!(this.fitment.ownerClient && this.fitment.ownerClient.organizationType && this.fitment.ownerClient.organizationType === 'BUREAU_OF_COMPULSORY_EXECUTION');

    },
    isOrgType() {
      return !!(this.fitment.ownerClient &&
          this.fitment.ownerClient.organizationType &&
          (this.fitment.ownerClient.organizationType === 'BUREAU_OF_COMPULSORY_EXECUTION'));
    },

    isOrgTypeMib() {
      return !!(this.fitment.ownerClient &&
          this.fitment.ownerClient.organizationType &&
          (this.fitment.ownerClient.organizationType === 'BUREAU_OF_COMPULSORY_EXECUTION' || this.fitment.ownerClient.organizationType === 'CUSTOMS_ADMINISTRATION'));
    },
    documentOrPassportLbl() {
      if (this.fitment) {
        if (this.fitment.ownerClient && this.fitment.ownerClient.type && this.fitment.ownerClient.type === 'Legal')
          return "asset.document";
        else
          return "asset.passport";
      } else {
        return "asset.passport";
      }
    },
    canConfirm() {
      return this.fitment.appraisalStatusEnum === 'Rated' && this.hasPermission('NEW_FITMENT_CONFIRM');
    },
    canReEvaluate() {
      return (this.fitment.appraisalStatusEnum === 'Rated' || this.fitment.appraisalStatusEnum === 'Confirmed') && this.hasPermission('NEW_FITMENT_REEVALUATE');
    },
    canSave() {
      // console.log("this.fitment =  ==", this.fitment)
      // console.log(
      //     this.fitment.entiteCreateType === 'API_EXARID' && !this.fitment.appraisalStatusEnum ||
      //     this.fitment.appraisalStatusEnum === 'Unreviewed' || this.fitment.appraisalStatusEnum === 'NotFullyEvaluated'
      //     | this.fitment.appraisalStatusEnum === 'SentToComplement'
      // )
      // return (this.fitment.entiteCreateType === 'API_EXARID' && !this.fitment.appraisalStatusEnum || this.fitment.appraisalStatusEnum === 'Unreviewed'
      //     || this.fitment.appraisalStatusEnum === 'NotFullyEvaluated' || this.fitment.appraisalStatusEnum === 'SentToComplement');
      return true;
    },
    canEvaluate() {
      return (this.fitment.appraisalStatusEnum === 'Unreviewed');
    },
    showReportButton() {
      return (this.fitment.appraisalStatusEnum === 'Rated' || this.fitment.appraisalStatusEnum === 'Confirmed') && this.fitment.id && this.fitment.id > 0;
    },
    sendToMIBAssetReport() {
      return (this.fitment.appraisalStatusEnum === 'Rated' || this.fitment.appraisalStatusEnum === 'Confirmed') && this.fitment.id && this.fitment.id > 0;
    },
    checkPaymentLbl() {
      return this.isOrgTypeMib ? "realEstate.field.checkPaymentFilesMib" : "realEstate.field.checkPaymentFiles";
    },
    isPaid() {
      return this.fitment.evlAmountPaid > 0;
    },
    canReject() {
      return this.hasPermission('NEW_FITMENT_EDIT')
          && (this.fitment.appraisalStatusEnum === 'Unreviewed' || (this.fitment.appraisalStatusEnum === 'NotFullyEvaluated' && this.isUserDirector))
          && !this.fitment.hasAppraiserReportEsp;
    },
    canRemoveFile() {
      return this.status && this.status !== 'Rated' && this.status !== 'Confirmed' && this.status !== 'Rejected' && this.hasPermission('NEW_FITMENT_IMAGE_DELETE')
    },
    canSendAgent() {
      return !this.fitment.appraisalStatusEnum && this.hasPermission('NEW_FITMENT_EDIT')
    },
    isTenders() {
      return this.fitment.evaluationRespectiveType === 'TENDERS';
    },
    isUserDirector() {
      return this.profile && this.profile.username === 'shohrux';
    }
  },
  methods: {
    init() {
      const vm = this;
      const id = this.$route.params.id;

      const promises = [];
      if (id && id > 0) {
        vm.isPageLoadInit = true;
        promises.push(this.$http.get('fitment/' + id));

        Promise.all(promises).then(function (values) {
          if (values.length >= 0) {
            const editData = values[0].data;
            if (!editData.evlGoalType) {
              editData.evlGoalType = '';
            }
            vm.contractDate = parseDate(editData.contractDate);
            vm.powerOfAttorneyDate = parseDate(editData.powerOfAttorneyDate);
            vm.tenderContractDate = parseDate(editData.tenderContractDate);
            vm.fitment = editData;
            vm.fitment.employee = {};
            if (vm.fitment) {
              vm.getMetalType(vm.fitment);
            }
            if (editData.employeeId && editData.employeeName) {
              vm.fitment.employee.id = editData.employeeId;
              vm.fitment.employee.text = editData.employeeName;
              vm.fitment.employee.name = editData.employeeName;
            }

            vm.fitment.actOfSaleFiles.forEach((file) => {
              vm.actOfSaleAllFiles.push(file);
            });
            vm.fitment.decisionFiles.forEach((file) => {
              vm.decisionAllFiles.push(file);
            });
            vm.fitment.letterFiles.forEach((file) => {
              vm.letterAllFiles.push(file);
            });
            vm.fitment.executivePlaylistFiles.forEach((file) => {
              vm.executivePlaylistAllFiles.push(file);
            });

            vm.status = editData.appraisalStatusEnum;
            vm.isPageLoadInit = false;
          }
        });
      }
    },
    cancel() {
      this.$router.push('/fitment/list');
    },

    removeItem(item) {

      console.log("item.id = ", item)
      this.$swal({
        title: this.$t('messages.common.warning'),
        text: this.$t('fitment.deleteConfirm'),
        type: 'warning',
        showCancelButton: true,
        confirmButtonColor: '#dd3333',
        confirmButtonText: 'Ўчириш',
        cancelButtonText: 'Бекор қилиш'
      }).then((result) => {
        if (result.value) {
          this.$http.delete('fitment/item/delete/' + item.id)
              .then((res) => {
                this.processing = false;
                if (res && res.data && res.data.status === 'SUCCESS') {
                  this.$swal({
                    title: this.$t('messages.common.success'),
                    text: this.$t('fitment.deleteSuccess'),
                    type: 'success'
                  });
                  window.location.reload();
                } else {
                  this.$swal({
                    title: this.$t('messages.common.warning'),
                    text: res.data.message,
                    type: 'warning'
                  });
                }

              }, () => {
                this.$swal({
                  title: this.$t('messages.common.error'),
                  text: this.$t('fitment.deleteError'),
                  type: 'error'
                });
                this.processing = false;
              });
        }
      });
    },

    showWarning(message) {
      this.$swal({
        title: this.$t("messages.common.warning"),
        text: message,
        type: "warning"
      });

      return false;
    },

    saveItem(item) {

      if (!item.productCategoryPlusDto || !item.productCategoryPlusDto.id) {
        return this.showWarning("Mahsulot kategoriyasini tanlang.");
      }

      if (!item.productSubCategoryPlusDto || !item.productSubCategoryPlusDto.id) {
        return this.showWarning("Mahsulot sub kategoriyasini tanlang.");
      }

      if (!item.productManufactureDto || !item.productManufactureDto.id) {
        return this.showWarning("Ishlab chiqaruvchini tanlang.");
      }

      if (!item.productModelDto || !item.productModelDto.id) {
        return this.showWarning("Modelni tanlang.");
      }

      if (!item.countryDto || !item.countryDto.id) {
        return this.showWarning("Davlatni tanlang.");
      }

      if (item.useWebSite === null || item.useWebSite === undefined) {
        return this.showWarning("Манба киритиш шарт.");
      }

      if (this.fitmentType !== 'JEWELRY') {
        if (!item.qty || item.qty < 1) {
          return this.showWarning("Сони камида 1 бўлиши керак.");
        }

        if (!item.conditionType) {
          return this.showWarning("Умумий холати танланг.");
        }

        if (!item.governmentPrice) {
          return this.showWarning("Нархини(Цена) киритинг.");
        }

        if (!item.currency) {
          return this.showWarning("Валюта қурслари танланг.");
        }

        if (!item.dilapidationValue) {
          return this.showWarning("Эскириш қийматини киритинг.");
        }

      }

      if (this.fitmentType === 'JEWELRY') {

        if (!item.hallmark) {
          return this.showWarning("Hallmark kiritilishi shart.");
        }

        if (!item.weigh) {
          return this.showWarning("Og'irligi kiritilishi shart.");
        }

        if (!item.stoneName) {
          return this.showWarning("Tosh nomini kiriting.");
        }

        if (!item.metalType) {
          return this.showWarning("Metal turini tanlang.");
        }

        if (!item.stonePrice) {
          return this.showWarning("Tosh narxini kiriting.");
        }

        if (!item.overlayCoefficient) {
          return this.showWarning("Overlay coefficientni kiriting.");
        }
      }


      this.$http.post('fitment/item/save', item)
          .then(res => {
            console.log("item = ", item)
            if (res && res.data && res.data.status === 'SUCCESS') {
              this.$swal({
                title: this.$t('messages.common.success'),
                text: this.$t('messages.realEstate.statusSuccess'),
                type: 'success'
              });
              this.$router.push('/fitment/plus/edit/' + res.data.data.id);
              this.editFitment(res.data.data.id);
            } else {
              this.$swal({
                title: this.$t('messages.common.warning'),
                text: this.$t('messages.realEstate.statusWarning'),
                type: 'warning'
              });
            }
            this.processing = false;
          }, () => {
            this.$swal({
              title: this.$t('messages.common.error'),
              text: this.$t('messages.realEstate.error'),
              type: 'error'
            });
            this.processing = false;
          });
    },

    save() {
      this.saveAndObjects();
    },
    saveAndObjects() {
      if (!this.fitment.dilapidationValue && this.fitment.fitmentType === 'INSTRUMENTS_INVENTORY_ANIMALS_EQUIPMENT_FIXED_ASSETS') {
        this.fitment.dilapidationValue = 0;
      }
      this.$v.$touch();
      if (this.$v.$invalid) {
        return;
      }
      if (this.fitment.prepayment && !(this.fitment.prepayment >= 0 && this.fitment.prepayment <= 100)) {
        this.$swal({
          title: this.$t('messages.common.warning'),
          text: this.$t('Олдиндан тўлов фоизи 0% дан 100% гача!'),
          type: 'warning'
        });
        return;
      }

      this.processing = true;

      if (this.contractDate) {
        this.fitment.contractDate = formatDate(this.contractDate);
      }

      if (this.tenderContractDate) {
        this.fitment.tenderContractDate = formatDate(this.tenderContractDate);
      }

      if (this.powerOfAttorneyDate) {
        this.fitment.powerOfAttorneyDate = formatDate(this.powerOfAttorneyDate);
      }

      if (this.fitment.employee) {
        this.fitment.employeeId = this.fitment.employee.id;
      }

      if (this.isMib) {
        this.fitment.evlContractAmount = 0;
      }
      this.$http.post('fitment/plus/save', this.fitment)
          .then(res => {

            if (res && res.data && res.data.status === 'SUCCESS') {
              this.$swal({
                title: this.$t('messages.common.success'),
                text: this.$t('messages.realEstate.statusSuccess'),
                type: 'success'
              });
              this.$router.push('/fitment/plus/edit/' + res.data.data.id);
              this.editFitment(res.data.data.id);
            } else {
              this.$swal({
                title: this.$t('messages.common.warning'),
                text: this.$t('messages.realEstate.statusWarning'),
                type: 'warning'
              });
            }
            this.processing = false;
          }, () => {
            this.$swal({
              title: this.$t('messages.common.error'),
              text: this.$t('messages.realEstate.error'),
              type: 'error'
            });
            this.processing = false;
          });
    },

    editFitment(id) {
      const vm = this;
      const promises = [];
      if (id && id > 0) {
        promises.push(this.$http.get('fitment/' + id));
        Promise.all(promises).then(function (values) {
          if (values.length >= 0) {
            const editData = values[0].data;
            if (!editData.evlGoalType) {
              editData.evlGoalType = '';
            }
            vm.contractDate = parseDate(editData.contractDate);
            vm.powerOfAttorneyDate = parseDate(editData.powerOfAttorneyDate);
            vm.fitment = editData;
            vm.fitment.employee = {};
            if (editData.employeeId && editData.employeeName) {
              vm.fitment.employee.id = editData.employeeId;
              vm.fitment.employee.text = editData.employeeName;
            }
          }
        });
      }
    },

    getMetalType() {
      const vm = this;
      const promises = [];
      let objectType = "Fitment";
      for (let i = 0; i < vm.fitment.evaluationFitments.length; i++) {
        promises.push(vm.$http.get('fitment/metalType/' + vm.fitment.evaluationFitments[i].id + '/' + vm.fitment.evaluationFitments[i].evlObjectId + '/' + objectType))
        Promise.all(promises).then(function (values) {
          if (values.length >= 0) {
            const result = values[0].data;

            vm.isNewStandard = result.data.isNewStandard;
            vm.metalTypes = result.data.metalType;
            if (!vm.fitment.evaluationFitments[i].usdCurrencyRate) {
              vm.fitment.evaluationFitments[i].usdCurrencyRate = result.data.usdRate;
            }
            if (!vm.fitment.evaluationFitments[i].eurCurrencyRate) {
              vm.fitment.evaluationFitments[i].eurCurrencyRate = result.data.eurRate;
            }
            if (!vm.fitment.evaluationFitments[i].rubCurrencyRate) {
              vm.fitment.evaluationFitments[i].rubCurrencyRate = result.data.rubRate;
            }
            if (!vm.fitment.evaluationFitments[i].vat) {
              vm.fitment.evaluationFitments[i].vat = result.data.vat;
            }
            if (!vm.fitment.evaluationFitments[i].road) {
              vm.fitment.evaluationFitments[i].road = result.data.road;
            }
            if (!vm.fitment.evaluationFitments[i].customsClearance) {
              vm.fitment.evaluationFitments[i].customsClearance = result.data.customsClearance;
            }
            if (result.data.minSalary) {
              vm.minSalary = result.data.minSalary;
            }
            if (vm.fitment.evaluationFitments[i].fitmentType === 'INSTRUMENTS_INVENTORY_ANIMALS_EQUIPMENT_FIXED_ASSETS') {
              vm.changeDilapidationValue14(i);
            } else if (vm.fitment.evaluationFitments[i].fitmentType === 'BUILDINGS_TRANSMITTERS_MACHINERY_EQUIPMENT') {
              vm.changeDilapidationValue15(i);
            }
          }

        });
      }
    },

    addEditPushItem(itemId, fitmentId) {
      this.$router.push({
        path: '/fitment/item/edit/' + itemId + '/' + fitmentId,
        query: {entiteCreateType: this.fitment.entiteCreateType}
      });
    },
    addFitment() {
      this.$router.push({
        path: '/fitment/item/new/' + this.fitment.id,
        query: {entiteCreateType: this.fitment.entiteCreateType}
      });
    },
    onOwnerSearch(searchTxt, loading) {
      loading(true);
      this.owners = [];
      this.ownerFilter.search = searchTxt;
      this.$http.post('customer/search', this.ownerFilter)
          .then(res => {
            this.owners = res.data.data;
            loading(false);
          }, err => {
            console.log(err);
          });
    },
    onOwnerFocus() {
      this.owners = [];
      this.ownerFilter.search = '';
      this.$http.post('customer/search', this.ownerFilter)
          .then(res => {
            this.owners = res.data.data;
          }, err => {
            console.log(err);
          });
    },
    onCustomerSearch(searchTxt, loading) {
      loading(true);
      this.customers = [];
      this.customerFilter.search = searchTxt;
      this.$http.post('customer/search', this.customerFilter)
          .then(res => {
            this.customers = res.data.data;
            loading(false);
          }, err => {
            console.log(err);
          });
    },
    onCustomerFocus() {
      this.customers = [];
      this.customerFilter.search = '';
      this.$http.post('customer/search', this.customerFilter)
          .then(res => {
            this.customers = res.data.data;
          }, err => {
            console.log(err);
          });
    },
    onEmployeeSearch(searchTxt, loading) {
      loading(true);
      this.employees = [];
      this.employeeFilter.search = searchTxt;
      this.$http.post('employes/search', this.employeeFilter)
          .then(res => {
            this.employees = res.data.data;
            loading(false);
          }, err => {
            console.log(err);
          });
    },
    onEmployeeFocus() {
      this.employees = [];
      this.employeeFilter.search = '';
      this.$http.post('employes/search', this.employeeFilter)
          .then(res => {
            this.employees = res.data.data;
          }, err => {
            console.log(err);
          });
    },
    onChangeEmployee() {
      if (this.fitment.employee) {
        this.fitment.employeeId = this.fitment.employee.id
      }
    },
    showDeleteFitmentItemDialog(item, index) {
      this.$swal({
        title: this.$t('messages.common.warning'),
        text: this.$t('asset.deleteConfirm'),
        type: 'warning',
        showCancelButton: true,
        confirmButtonColor: '#dd3333',
        confirmButtonText: 'Ўчириш',
        cancelButtonText: 'Бекор қилиш'
      }).then((result) => {
        if (result.value) {
          this.$http.delete('fitment/item/delete/' + item.id)
              .then((res) => {
                if (res && res.data && res.data.status === 'SUCCESS') {
                  this.$swal({
                    title: this.$t('messages.common.success'),
                    text: this.$t('messages.fitment.deleteSuccess'),
                    type: 'success'
                  });
                  this.fitment.evaluationFitments.splice(index, 1);
                } else {
                  this.$swal({
                    title: this.$t('messages.common.warning'),
                    text: res.data.message,
                    type: 'warning'
                  });
                }
                this.processing = false;
              }, () => {
                this.$swal({
                  title: this.$t('messages.common.error'),
                  text: this.$t('messages.fitment.deleteError'),
                  type: 'error'
                });
                this.processing = false;
              });
        }
      });
    },
    changeStatus(status) {
      this.processing = true;
      this.isPageLoadInit = true;

      this.$http.get('contractRegion/check-contract/' + this.fitment.id + "/Fitment").then(response => {
        if (response.data.status !== 'SUCCESS' || response.data.status === 'SUCCESS' && response.data.code === 'ALLOWED') {
          this.$swal({
            title: this.$t('messages.common.warning'),
            text: response.data.message,
            type: 'warning',
            showCancelButton: true,
            confirmButtonColor: '#dd3333',
            confirmButtonText: 'Давом этиш',
            cancelButtonText: 'Бекор қилиш'
          }).then((result) => {
            if (result.value) {
              this.sendChangesToServer(status);
            }
            this.processing = false;
          });
        } else {
          this.sendChangesToServer(status);
        }
      });
    },
    sendChangesToServer(status) {
      this.$http.post('change/status', {
        id: this.fitment.id,
        appraisalStatusEnum: status,
      }).then(res => {
        if (res && res.data) {
          if (res.data.status === 'SUCCESS') {
            this.$swal({
              title: this.$t('messages.common.success'),
              text: this.$t('messages.fitment.statusSuccess'),
              type: 'success'
            });
            this.fitment.appraisalStatusEnum = status;
            this.status = status;
            if (status === 'Confirmed') {
              if (this.fitment.hasEsp) {
                this.openSignPageDirector(this.fitment);
              }
            } else if (status === 'Rated') {
              if (this.fitment.hasEsp) {
                this.openSignPageAppraiser(this.fitment);
              }
            } else if (status === 'Unreviewed') {
              window.location.reload();
            }

          } else if (res.data.status === 'ERROR') {
            this.$swal({
              title: this.$t('messages.common.warning'),
              text: res.data.message,
              type: 'warning'
            });
          }
        } else {
          this.$swal({
            title: this.$t('messages.common.warning'),
            text: this.$t('messages.fitment.statusWarning'),
            type: 'warning'
          });
        }
        this.processing = false;
        this.isPageLoadInit = false;
      }, () => {
        this.$swal({
          title: this.$t('messages.common.error'),
          text: this.$t('messages.fitment.statusError'),
          type: 'error'
        });
        this.processing = false;
        this.isPageLoadInit = false;
      });
    },
    reportPdf: function (fitment) {
      this.loading.isPdfLoading = true;
      this.downloadFile('/v2/fitmentReport/pdf/' + fitment.hashUuid + '/WITH_SIGNATURE',
          'Хисобот ' + fitment.ownerClient.fullName + '.pdf',
          'application/pdf',
          'isPdfLoading');
    },
    notSignedAndQRCodeReportPdf: function (fitment) {
      this.loading.isPdfNotSignedAndQRCodeLoading = true;
      this.downloadFile('/v2/fitmentReportNotSignedAndQRCode/pdf/' + fitment.hashUuid + '/WITH_SIGNATURE',
          'Хисобот ' + fitment.ownerClient.fullName + '.pdf',
          'application/pdf',
          'isPdfNotSignedAndQRCodeLoading');
    },
    reportPdfQrCode: function (fitment) {
      this.loading.isPdfQrLoading = true;
      this.downloadFile('/v2/fitmentReport/pdf/' + fitment.hashUuid + '/WITH_QR_CODE',
          'Хисобот ' + fitment.ownerClient.fullName + '.pdf',
          'application/pdf',
          'isPdfQrLoading');
    },
    reportDoc: function (fitment) {
      this.loading.isDocLoading = true;
      this.downloadFile('/v2/fitmentReport/doc/' + fitment.hashUuid + '/WITH_SIGNATURE',
          'Хисобот ' + fitment.ownerClient.fullName + '.doc',
          'application/doc',
          'isDocLoading');
    },
    notSignedAndQRCodeReportDoc: function (fitment) {
      this.loading.isDocNotSignedAndQRCodeLoading = true;
      this.downloadFile('/v2/fitmentReportNotSignedAndQRCode/doc/' + fitment.hashUuid + '/WITH_SIGNATURE',
          'Хисобот ' + fitment.ownerClient.fullName + '.doc',
          'application/doc',
          'isDocNotSignedAndQRCodeLoading');
    },
    reportDocQrCode: function (fitment) {
      this.loading.isDocQrLoading = true;
      this.downloadFile('/v2/fitmentReport/doc/' + fitment.hashUuid + '/WITH_QR_CODE',
          'Хисобот ' + fitment.ownerClient.fullName + '.doc',
          'application/doc',
          'isDocQrLoading');
    },
    downloadFile: function (url, name, type, loading) {
      this.$http.get(url, {responseType: 'arraybuffer'})
          .then(response => {
            let blob = new Blob([response.data], {type: type});
            let link = document.createElement("a");
            link.href = window.URL.createObjectURL(blob);
            link.download = name;
            link.click();
            this.loading[loading] = false;
          })
          .catch(err => {
            console.log(err);
            this.loading[loading] = false;
            if (err.response && err.response.status === 429) {
              this.$reportSwal(err.response, () => this.downloadFile(url, name, type, loading))
            }
          })
    },
    contractDocQrCode: function (fitment) {
      this.loading.isCDocQrLoading = true;
      this.downloadFile('/v2/fitmentContract/doc/' + fitment.hashUuid + '/WITH_QR_CODE',
          'Шартнома ' + fitment.ownerClient.fullName + '.doc',
          'application/doc',
          'isCDocQrLoading');
    },
    contractDoc: function (fitment) {
      this.loading.isCDocLoading = true;
      this.downloadFile('/v2/fitmentContract/doc/' + fitment.hashUuid + '/WITH_SIGNATURE',
          'Шартнома ' + fitment.ownerClient.fullName + '.doc',
          'application/doc',
          'isCDocLoading');
    },
    contractPdf: function (fitment) {
      this.loading.isCPdfLoading = true;
      this.downloadFile('/v2/fitmentContract/pdf/' + fitment.hashUuid + '/WITH_SIGNATURE',
          'Шартнома ' + fitment.ownerClient.fullName + '.pdf',
          'application/pdf',
          'isCPdfLoading');
    },
    contractQrCodePdf: function (fitment) {
      this.loading.isCPdfQrLoading = true;
      this.downloadFile('/v2/fitmentContract/pdf/' + fitment.hashUuid + '/WITH_QR_CODE',
          'Шартнома ' + fitment.ownerClient.fullName + '.pdf',
          'application/pdf',
          'isCPdfQrLoading');
    },
    sendReportToMIBAsset: function (fitment) {
      this.processing = true;
      this.$http.get('/sendApiMibConfirmReport/pdf/' + fitment.id + '/WITH_QR_CODE/Fitment', {responseType: 'arraybuffer'})
          .then(response => {
            if (response && response.status === 200) {
              this.$swal({
                title: this.$t('messages.common.success'),
                text: this.$t('realEstate.report.titleQrCode'),
                type: 'success'
              });
            } else {
              this.$swal({
                title: this.$t('messages.common.warning'),
                text: this.$t('messages.common.error'),
                type: 'warning'
              });
            }
            this.processing = false;
          })
          .catch(err => {
            console.log(err);
            this.$swal({
              title: this.$t('messages.common.warning'),
              text: this.$t('messages.common.error'),
              type: 'warning'
            });
            this.processing = false;
          })
    },
    showReport: function () {
      this.$http.post('fitment/show-report/' + this.fitment.id + '/' + this.fitment.displayReport)
          .then(res => {
            if (res && res.data && res.data.status === 'SUCCESS') {
              this.$swal({
                title: this.$t('messages.common.success'),
                text: this.$t('messages.realEstate.showReportSuccess'),
                type: 'success'
              });
              this.fitment.appraisalStatusEnum = status;
            } else if (res && res.data && res.data.status === 'FAIL') {
              this.$swal({
                title: this.$t('messages.common.success'),
                text: this.$t('messages.realEstate.showCancelReportSuccess'),
                type: 'success'
              });
            }
          }, () => {
            this.$swal({
              title: this.$t('messages.common.error'),
              text: this.$t('messages.realEstate.showReportError'),
              type: 'error'
            });
          });
    },
    getEvaluationRespectiveType() {
      this.$http.get('/evaluationRespectiveType').then(response => {
        this.evaluationRespectiveTypes = response.data;
      }, err => {
        console.log(err)
      });
    },
    deleteFitment: function (fitment) {
      this.processing = true;
      this.$swal({
        title: this.$t('messages.common.warning'),
        text: this.$t('fitment.deleteConfirm'),
        type: 'warning',
        showCancelButton: true,
        confirmButtonColor: '#dd3333',
        confirmButtonText: 'Ўчириш',
        cancelButtonText: 'Бекор қилиш'
      }).then((result) => {
        if (result.value) {
          this.$http.delete('delete/appraisal/' + fitment.id)
              .then((res) => {
                console.log(res.data);
                if (res && res.data && res.data.status === 'SUCCESS') {
                  this.$swal({
                    title: this.$t('messages.common.success'),
                    text: this.$t('fitment.deleteSuccess'),
                    type: 'success'
                  });
                  this.$router.push('/fitment/list');
                } else {
                  this.$swal({
                    title: this.$t('messages.common.warning'),
                    text: res.data.message,
                    type: 'warning'
                  });
                }
                this.processing = false;
              }, () => {
                this.$swal({
                  title: this.$t('messages.common.error'),
                  text: this.$t('fitment.deleteError'),
                  type: 'error'
                });
                this.processing = false;
              });
        } else {
          this.processing = false;
        }
      });
    },
    rejectOrder() {
      this.$eventBus.$emit('RejectComment', this.fitment.id, false, "Fitment");
    },
    openSignPageDirector: function (fitment) {
      this.processing = true;
      this.$http.get('/esign/director/' + fitment.id + '/Fitment')
          .then(response => {
            if (response && response.status === 200) {
              window.open(response.data.data);
            } else {
              this.$swal({
                title: this.$t('messages.common.warning'),
                text: response.data.message,
                type: 'warning'
              });
            }
            this.processing = false;
          })
          .catch(err => {
            console.log(err);
            this.$swal({
              title: this.$t('messages.common.warning'),
              text: this.$t('messages.common.error'),
              type: 'warning'
            });
            this.processing = false;
          })
    },
    openSignPageAppraiser: function (fitment) {
      this.processing = true;
      this.$http.get('/esign/appraiser/' + fitment.id + '/Fitment')
          .then(response => {
            if (response && response.status === 200) {
              window.open(response.data.data);
            } else {
              this.$swal({
                title: this.$t('messages.common.warning'),
                text: response.data.message,
                type: 'warning'
              });
            }
            this.processing = false;
          })
          .catch(err => {
            console.log(err);
            this.$swal({
              title: this.$t('messages.common.warning'),
              text: this.$t('messages.common.error'),
              type: 'warning'
            });
            this.processing = false;
          })
    },
    isRoleDirector() {
      const authorities = this.$store.state.profile.authorities;
      for (const role of authorities) {
        if (role == "ROLE_DIRECTOR") {
          return this.isDirector = true;
        }

      }
    },
    isRoleAppraiser() {
      const authorities = this.$store.state.profile.authorities;
      for (const role of authorities) {
        if (role == "ROLE_APPRAISER") {
          return this.isAppraiser = true;
        }
      }
    },
    sendingToAgent() {
      this.processing = true;
      this.isPageLoadInit = true;
      this.$http.get('/fitment/send-agent/' + this.fitment.id).then(response => {
        this.$swal({
          title: this.$t('messages.common.success'),
          text: response.data.message,
          type: 'success'
        });
        this.processing = false;
      }).catch(err => {
        console.log(err);
        this.$swal({
          title: this.$t('messages.common.warning'),
          text: this.$t('messages.common.error'),
          type: 'warning'
        });
        this.processing = false;
      });
    },
    addFitments() {
      let item = {
        //rowIndex: this.realEstate.buildings.length
      };
      this.fitment.evaluationFitments.push(item);
    },
    onCategorySearch(searchTxt, loading) {
      loading(true);
      this.productCategoryFilter.search = searchTxt;
      this.searchMethodCategory(loading);
    },
    onCategoryFocus() {
      this.productCategoryFilter.search = '';
      this.searchMethodCategory();
    },
    searchMethodCategory(loading) {
      this.productCategories = [];
      this.productSubCategories = [];
      this.productCategoryFilter.objectId = this.fitment.parentId;
      this.$http.post('product-category-plus/search', this.productCategoryFilter).then(res => {
        if (loading)
          loading(false);
        this.productCategories = res.data.data;
      }, err => {
        console.log(err);
      });
    },


    onSubCategorySearch(searchTxt, loading, index) {
      if (!this.fitment.evaluationFitments[index].productCategoryPlusDto) {
        return;
      }
      loading(true);
      this.subCategoryFilter.search = searchTxt;
      this.subCategoryFilter.parentId = this.fitment.evaluationFitments[index].productCategoryPlusDto.id;
      this.searchMethodSubCategory(loading);
    },

    onSubCategoryFocus(index) {
      if (!this.fitment.evaluationFitments[index].productCategoryPlusDto) {
        return;
      }
      this.subCategoryFilter.search = '';
      this.subCategoryFilter.parentId = this.fitment.evaluationFitments[index].productCategoryPlusDto.id;
      this.searchMethodSubCategory();
    },

    searchMethodSubCategory(loading) {
      this.productSubCategories = [];
      this.$http.post('product-sub-category-plus/search', this.subCategoryFilter)
          .then(res => {
            if (loading)
              loading(false);
            this.productSubCategories = res.data.data;
          }, err => {
            console.log(err);
          });
    },

    onChangeMethodSub(index) {
      if (this.fitment.evaluationFitments[index].productCategoryPlusDto.fitmentType) {
        this.fitment.evaluationFitments[index].fitmentType = this.fitment.evaluationFitments[index].productCategoryPlusDto.fitmentType;
        this.fitment.evaluationFitments[index].customsDuty = this.fitment.evaluationFitments[index].productCategoryPlusDto.customsDuty;
      }
    },

    onProductManufactureSearch(searchTxt, loading, index) {
      loading(true);
      this.productManufactureFilter.search = searchTxt;
      this.productManufactureFilter.productCategoryId = this.fitment.evaluationFitments[index].productCategoryPlusDto.id;
      this.productManufactureFilter.productSubCategoryId = this.fitment.evaluationFitments[index].productSubCategoryPlusDto.id;
      this.searchProductManufacture(loading);
    },

    onProductManufactureFocus(index) {
      this.productManufactureFilter.search = '';
      this.productManufactureFilter.productCategoryId = this.fitment.evaluationFitments[index].productCategoryPlusDto.id;
      this.productManufactureFilter.productSubCategoryId = this.fitment.evaluationFitments[index].productSubCategoryPlusDto.id;
      this.searchProductManufacture();
    },

    searchProductManufacture(loading) {
      this.manufactures = [];
      this.$http.post('product-manufacture/search', this.productManufactureFilter)
          .then(res => {
            if (loading)
              loading(false);
            this.manufactures = res.data.data;
          }, err => {
            console.log(err);
          });
    },

    onProductModelSearch(searchTxt, loading, index) {
      loading(true);
      this.productModelFilter.search = searchTxt;

      this.productModelFilter.productCategoryId = this.fitment.evaluationFitments[index].productCategoryPlusDto.id;
      this.productModelFilter.productSubCategoryId = this.fitment.evaluationFitments[index].productSubCategoryPlusDto.id;
      this.productModelFilter.productManufactureId = this.fitment.evaluationFitments[index].productManufactureDto.id;

      this.searchProductModel(loading);
    },

    onProductModelFocus(index) {
      this.productModelFilter.search = '';
      this.productModelFilter.productCategoryId = this.fitment.evaluationFitments[index].productCategoryPlusDto.id;
      this.productModelFilter.productSubCategoryId = this.fitment.evaluationFitments[index].productSubCategoryPlusDto.id;
      this.productModelFilter.productManufactureId = this.fitment.evaluationFitments[index].productManufactureDto.id;
      this.searchProductModel();
    },

    searchProductModel(loading) {
      this.productModels = [];
      this.$http.post('product-model/search', this.productModelFilter)
          .then(res => {

            if (loading)
              loading(false);
            this.productModels = res.data.data;
          }, err => {
            console.log(err);
          });
    },

    onChangeMethodModal() {
      if (this.fitment.productModelDto) {
        this.fitment.fitmentType = this.fitment.productModelDto.fitmentType.code;
      }
    },

    onCountrySearch(searchTxt) {
      this.countryList = [];
      this.filter.search = searchTxt;
      this.$http.post('country/search', this.filter)
          .then(res => {
            this.countryList = res.data.data;
          }, err => {
            console.log(err);
          });
    },
    onCountryFocus() {
      this.countryList = [];
      this.filter.search = '';
      this.$http.post('country/search', this.filter)
          .then(res => {
            this.countryList = res.data.data;
          }, err => {
            console.log(err);
          });
    },

    changeDilapidationValue14(index) {
      if (!this.fitment.evaluationFitments[index].dilapidationValue) {
        return;
      }

      if (this.fitment.evaluationFitments[index].dilapidationValue <= 80) {
        if (this.fitment.evaluationFitments[index].dilapidationValue < 6) {
          this.fitment.evaluationFitments[index].technicalCondition = 'New';
          this.technicalConditionText = 'Янги';
        } else if (this.fitment.evaluationFitments[index].dilapidationValue < 20) {
          this.fitment.evaluationFitments[index].technicalCondition = 'VeryGood';
          this.technicalConditionText = 'Жуда яхши';
        } else if (this.fitment.evaluationFitments[index].dilapidationValue < 41) {
          this.fitment.evaluationFitments[index].technicalCondition = 'Good';
          this.technicalConditionText = 'Яхши';
        } else if (this.fitment.evaluationFitments[index].dilapidationValue < 61) {
          this.fitment.evaluationFitments[index].technicalCondition = 'Satisfactory';
          this.technicalConditionText = 'Қониқарли';
        } else if (this.fitment.evaluationFitments[index].dilapidationValue <= 80) {
          this.fitment.evaluationFitments[index].technicalCondition = 'Dissatisfied';
          this.technicalConditionText = 'Қониқарсиз';
        }
        this.calculated(index);
      } else {
        this.fitment.evaluationFitments[index].dilapidationValue = 80;
      }
    },

    changeDilapidationValue15(index) {
      if (!this.fitment.evaluationFitments[index].dilapidationValue) {
        return;
      }
      if (this.fitment.evaluationFitments[index].dilapidationValue === 0 || this.fitment.evaluationFitments[index].dilapidationValue === 5) {
        this.fitment.evaluationFitments[index].technicalCondition = 'New';
        this.technicalConditionText = 'Янги';
      } else if (this.fitment.evaluationFitments[index].dilapidationValue === 10 || this.fitment.evaluationFitments[index].dilapidationValue === 15) {
        this.fitment.technicalCondition = 'VeryGood';
        this.technicalConditionText = 'Жуда яхши';
      } else if (this.fitment.evaluationFitments[index].dilapidationValue === 20 || this.fitment.evaluationFitments[index].dilapidationValue === 25 ||
          this.fitment.evaluationFitments[index].dilapidationValue === 30 || this.fitment.evaluationFitments[index].dilapidationValue === 35) {
        this.fitment.evaluationFitments[index].technicalCondition = 'Good';
        this.technicalConditionText = 'Яхши';
      } else if (this.fitment.evaluationFitments[index].dilapidationValue === 40 || this.fitment.evaluationFitments[index].dilapidationValue === 45 ||
          this.fitment.evaluationFitments[index].dilapidationValue === 50 || this.fitment.evaluationFitments[index].dilapidationValue === 55 || this.fitment.evaluationFitments[index].dilapidationValue === 60) {
        this.fitment.evaluationFitments[index].technicalCondition = 'Satisfactory';
        this.technicalConditionText = 'Қониқарли';
      } else if (this.fitment.evaluationFitments[index].dilapidationValue === 65 || this.fitment.evaluationFitments[index].dilapidationValue === 70 ||
          this.fitment.evaluationFitments[index].dilapidationValue === 75 || this.fitment.evaluationFitments[index].dilapidationValue === 80) {
        this.fitment.evaluationFitments[index].technicalCondition = 'ConditionallyAvailable';
        this.technicalConditionText = 'Шартли равишда яроқли';
      } else if (this.fitment.evaluationFitments[index].dilapidationValue === 85 || this.fitment.evaluationFitments[index].dilapidationValue === 90) {
        this.fitment.evaluationFitments[index].technicalCondition = 'Dissatisfied';
        this.technicalConditionText = 'Қониқарсиз';
      } else if (this.fitment.evaluationFitments[index].dilapidationValue === 97.5 || this.fitment.evaluationFitments[index].dilapidationValue === 100) {
        this.fitment.evaluationFitments[index].technicalCondition = 'ToBad';
        this.technicalConditionText = 'Қўллашга яроқсиз';
      }
      this.calculated(index);
    },

    umchange(um, index) {
      this.fitment.evaluationFitments[index].unitMeasurementType = um.name
    },
    calculated(index) {
      const vm = this;
      if (vm.fitment.evaluationFitments[index].fitmentType !== 'JEWELRY') {
        let rate = 1;
        let usdPrice = vm.fitment.evaluationFitments[index].qty * vm.fitment.evaluationFitments[index].governmentPrice / vm.fitment.evaluationFitments[index].usdCurrencyRate;
        if (vm.fitment.evaluationFitments[index].currency === "USD") {
          rate = vm.fitment.evaluationFitments[index].usdCurrencyRate;
          usdPrice = vm.fitment.evaluationFitments[index].qty * vm.fitment.evaluationFitments[index].governmentPrice;
        } else if (vm.fitment.evaluationFitments[index].currency === "EUR") {
          rate = vm.fitment.evaluationFitments[index].eurCurrencyRate;
          usdPrice = vm.fitment.evaluationFitments[index].qty * vm.fitment.evaluationFitments[index].governmentPrice * rate / vm.fitment.evaluationFitments[index].usdCurrencyRate;
        } else if (vm.fitment.evaluationFitments[index].currency === "RUB") {
          rate = vm.fitment.evaluationFitments[index].rubCurrencyRate;
          usdPrice = vm.fitment.evaluationFitments[index].qty * vm.fitment.evaluationFitments[index].governmentPrice * rate / vm.fitment.evaluationFitments[index].usdCurrencyRate;
        }

        let netAmount = vm.fitment.evaluationFitments[index].qty * vm.fitment.evaluationFitments[index].governmentPrice * rate;
        if (vm.fitment.evaluationFitments[index].hasCustomsDuty) {
          if (vm.isNewStandard) {
            vm.getCoefficient(usdPrice);
            vm.fitment.evaluationFitments[index].customsClearance = vm.coefficient * vm.minSalary;
          }
          if (!vm.isNewStandard) {
            netAmount =
                netAmount +
                (netAmount * vm.fitment.evaluationFitments[index].vat / 100) +
                (netAmount * vm.fitment.evaluationFitments[index].road / 100) +
                (netAmount * vm.fitment.evaluationFitments[index].customsClearance / 100) +
                (netAmount * vm.fitment.evaluationFitments[index].customsDuty / 100);
          } else {
            netAmount =
                netAmount + vm.fitment.evaluationFitments[index].customsClearance +
                (netAmount * vm.fitment.evaluationFitments[index].vat / 100) +
                (netAmount * vm.fitment.evaluationFitments[index].road / 100) +
                (netAmount * vm.fitment.evaluationFitments[index].customsDuty / 100);
          }
        }
        let dilapidationValue = vm.fitment.evaluationFitments[index].dilapidationValue ? vm.fitment.evaluationFitments[index].dilapidationValue : 0;
        vm.fitment.evaluationFitments[index].totalGovPrice = (netAmount - (netAmount * (dilapidationValue / 100)));

      } else if (vm.fitment.evaluationFitments[index].metalType && vm.metalTypes.length > 0) {
        for (let i = 0; i < vm.metalTypes.length; i++) {
          let field = vm.metalTypes[i];
          if (field.code === vm.fitment.evaluationFitments[index].metalType) {
            vm.fitment.evaluationFitments[index].metalRate = field.rate;
            vm.fitment.evaluationFitments[index].metalTypeName = field.displayName.toLowerCase();
            vm.fitment.evaluationFitments[index].gramPriceInSum = (vm.fitment.evaluationFitments[index].metalRate / 31.1034769 * vm.fitment.evaluationFitments[index].usdCurrencyRate);
            vm.fitment.evaluationFitments[index].governmentPrice = vm.fitment.evaluationFitments[index].gramPriceInSum * vm.fitment.evaluationFitments[index].hallmark * vm.fitment.evaluationFitments[index].weigh * vm.fitment.evaluationFitments[index].overlayCoefficient;
            vm.fitment.evaluationFitments[index].totalGovPrice = vm.fitment.evaluationFitments[index].governmentPrice + vm.fitment.evaluationFitments[index].stonePrice;
            vm.fitment.evaluationFitments[index].useWebSite = field.source;
            vm.fitment.evaluationFitments[index].metalType = field.code;
            vm.fitment.evaluationFitments[index].um = "GRAM"
          }
        }
      }
    },
    getCoefficient(usdPrice) {
      if (usdPrice < 10000) {
        this.coefficient = 1;
      } else if (usdPrice < 20000) {
        this.coefficient = 1.5;
      } else if (usdPrice < 40000) {
        this.coefficient = 2.5;
      } else if (usdPrice < 60000) {
        this.coefficient = 4;
      } else if (usdPrice < 100000) {
        this.coefficient = 8;
      } else if (usdPrice < 200000) {
        this.coefficient = 15;
      } else if (usdPrice < 500000) {
        this.coefficient = 30;
      } else if (usdPrice < 1000000) {
        this.coefficient = 58;
      } else {
        this.coefficient = 75;
      }
    }
  },
  created() {
    this.init();
    this.getEvaluationRespectiveType();
    this.isRoleDirector();
    this.isRoleAppraiser();
  }
}
</script>

<style scoped>

</style>
